export default {
  vote: {
    team: {
      about_title: 'Regras',
      about_con:
        '<p>1. O membro da equipa pode convidar dois amigos para formar uma equipa para participar do sorteio da sorte.</p>\
        <p>2. Os presentes são 1 dia VIP, 7 dias VIP, 30 dias VIP, telefone, TV, decodificador, cartão de recarga.</p>\
        <p>3. Apenas novos despositivos e contas identificadas como novos usuários podem fazer parte da equipa.</p>\
        <p>4. Cada utilizador tem um máximo de dez opurtunidades de sorte.</p>\
        <p>5. A actividade é válida até 25/12/2019.</p>\
        <p>6. A StarTimes ON reserva-se todo o direito de interpretação final.</p>',
      my_prizes: 'Meus Prémios',
      my_won: 'GANHOU: {0} Dias VIP',
      share_btn: 'Partilha a Tua Sorte e Ganha Mais',
      invite_tips: 'Convida 2 Amigos para Se Juntarem e Ganharem o Grande Prémio',
      invite_btn: 'Convida os amigos para se juntarem',
      invite_btn2: 'Inscreva-se e conte aos amigos',
      share10_1: 'Orgulhosos de Ti!',
      share10_2: 'Formou 1-10 Equipas!',
      invite_con: 'Junta-te à minha equipa e terás VIP e poderás assistir de borla.',
      invite_ima: '{0} convite para te juntares à equipa e ganhares VIP e presentes.',
      ima_saved: 'Guardado no ficheiro local',
      copied: 'copied',
      copy_text: 'CÓPIA DE',
      search_team: 'Procura equipa',
      search: 'PROCURAR',
      search_nores: 'Oops, sem resultados.',
      join: 'JUNTA-TE À EQUIPA',
      join_s: 'JUNTE-SE',
      reserves: 'O prémio estará efetivo imediatamente em EU.',
      form_late: 'Oops, estás um pouco atrasado, forma uma nova equipa.',
      form_newbtn: 'FORMA UMA NOVA EQUIPA',
      form_succ: 'Parabéns! Formaste com sucesso uma nova equipa, tens uma oportunidade de ganhar VIP e presente!',
      form_noform: 'Desculpa, ainda não formaste equipa. Partilha com os teus amigos!',
      boardcast_con: '{0} ganhou {1}!',
      invite_tip: '{0} <br/>convidou-te a fazer parte da equipa e ganhar prémios!',
      full_team: 'Desculpa, a equipa tem membros suficientes.',
      follow_team: 'Os equipas seguintes ainda têm uma vaga. Junta-te agora!',
      invite_won: '{0} pessoas já ganharam VIP.',
      team_id: 'ID da equipe',
      invite_infotit: 'Assiste TV ao Vivo e Aproveita o Melhor do VOD',
      joinpop_newuser: 'Esperando por ti, preciona para te juntares.',
      change: 'Muda',
      joinpop_olduser:
        'Oh, meu antigo amigo. Só os novos usuários se podem juntar. Também podes convidar amigos e fazer uma nova equipa para ganharem prémios.',
      download_tip: 'Começa agora a baixar o apk? (12M)',
      show_lucky: 'MOSTRA-LHES O QUÃO SORTUDO EU SOU',
      download_join: 'Baixa para te juntares a nós',
      have_team: 'Só podes estar numa equipa de cada vez.',
      input_error: 'Por favor insere uma identidade da equipa válida.',
      network_error: 'Falha de rede.',
      tips: `Tips: <br/>O VIP que ganhaste será efectivo à partir de hoje.`,
      no_awards: 'Ainda não tem prémio.',
      draw_title: 'Desenhe seu presente',
      draw_button: 'SORTE',
      draw_none: 'Obrigado, da próxima vez será melhor.',
      my_won_one: 'GANHOU: {0} Dia VIP',
      facebook: 'Facebook',
      whatsapp: 'Whatsapp',
      xender: 'Xender',
      download: 'Salvar imagem',
      copy: 'Copiar o link',
      download_apk: 'Download Now',

      //add
      shareTitle: 'Make A Team to Win Free VIPS',
      shareText: 'Join my team and send you VIP to watch it all for free',
      countdownTitle: 'Remaining',
      enterID: 'insira o ID da equipe',
      welcome: 'Bem vindo',
      newuser_popup: 'se você foi convidado por amigos',
      or: 'ou',

      //no need
      prize_step: 'Segue as instruções à baixo para ganhar os prémios.'
    },
    euro: {
      rules: 'Prizes',
      rule_title: `<p style="color:#F3953A;font-weight:bold">Rules and Prizes</p>`,
      rule_text: `<p>1.Activity time:</p>
      <p>The activity is from June 7th to July 13th, and we will do two predictions:</p>
      <p>a.June 7th to June 19th, predicting where each team in each of the six groups will finish and the four best third-placed teams who will go to the knockout stage;</p>
      <p>b.June 24th to July 6th, predicting which team win into the next round and which teamwill get the crown in the final.</p>
      <p>2.Activity prizes:</p>
      <p>Prediction Award:</p>
      <p>1-year free Max package.</p>
      <p>Lucky Award:</p>
      <p>1-month free Max package</p>
      <p>1-week free Max package</p>
      <p>3-days free Max package</p>
      <p>1-day free Max package</p>
      <p>3.Activity Rules:</p>
      <p>a.All need to register and log in before participating the prediction activity;</p>
      <p>b.Only if you link your DVB card with OTT account, then you can have a chance to win Prediction Award.</p>
      <p>c.Participate to get points. In the group stage, you will get 2 points every time you correctly predict the position of one team, and you will get 1 point for each team in the best 4 third-placed teams, a total of 52 points. In the knockout stage, you need to predict before the game starts, otherwise you won’t get points of this game. You willget 3 points for each team in round of 16 and quarter-finals, and you will get 4 points for each team in semi-finals and final match, a total of 48 points. If you participate in these two predictions, you have chance to get 100 points. Finally, you will get lucky awards according to your points.</p>
      <p>4.Activity awards:</p>
      <p>a.Prediction Award: </p>
      <p>Winners of prediction award will be randomly selected from people who predict the most accurately on the June 25th and July 13th. The results will be displayed on the Facebook and prediction page.</p>
      <p>b.Lucky Award: </p>
      <p>Points: >=90, 1 months Max package</p>
      <p>Points: <90 and >=70, 1 week Max package</p>
      <p>Points: <70 and >=50, 3 days Max package</p>
      <p>Points: <50 and > =30, 1 day Max package</p>
      <p>During the event, if you log in for more than 10 days, you will surely win a lucky award.</p>
      <p>These prizes will be released to the winners’ account in the 3 to 5 working days after the end of event.</p>
      <p>5.Additional information</p>
      <p>a.You need to provide an exact phone number and keep it unblocked. The phone number is an important certificate for awarding;</p>
      <p>b.Malicious registration is prohibited. If any malicious registration is found, the organizer has the right to cancel the qualification of the event and reserve the right to pursue their legal responsibility;</p>
      <p>c.The deadline for redemption is July 20th, if we fail to get in touch with you before the deadline, it will be considered invalid.</p>
      <p>d.The organizer reserves the right to change these terms and reserves the right to final interpretation.</p>`,
      rule_text_ug: `<p>1.Activity time:</p>
      <p>The activity is from June 7th to July 13th, and we will do two predictions:
      a.June 7th to June 19th, predicting where each team in each of the six groups will finish and the four best third-placed teams who will go to the knockout stage;</p>
      <p>b.June 24th to July 6th, predicting which team win into the next round and which teamwill get the crown in the final.</p>
      <p>Besides these two predictions, there will be four lotteries for all users who participate in the prediction activity and meet the conditions, on the June 18th, June 25th, July 1st, July 11th.</p>
      <p>2.Activity prizes:</p>
      <p>Prediction Award:</p>
      <p>First Prize:   10M UGX (Individual prize）</p>
      <p>Second Prize:   Senke Motorcycle (3 highest score)</p>
      <p>Third Prize:   StarTimes 32 inch TV</p>
      <p>Fourth Prize:   Euro 2020 Football</p>
      <p>Lottery Award:</p>
      <p>First Prize:   Senke Motorcycle (2 lucky customers)</p>
      <p>Second Prize:   StarTimes 32 inch TV</p>
      <p>Third Prize:   Euro 2020 Football</p>
      <p>Fourth Prize:   Euro 2020 Jersey</p>
      <p>Lucky Award:</p>
      <p>  1-month free Max package</p>
      <p>  1-week free Max package</p>
      <p>  3-days free Max package</p>
      <p>  1-day free Max package</p>
      <p>3.Activity Rules:</p>
      <p>a.All need to register and log in before participating the prediction activity;</p>
      <p>b.Only if you link your DVB card with OTT account, meet at least one of the following conditions during this event period from June 1st to July 11th and before the draw, then you can have a chance to win physical prizes: Prediction Award and Lottery Award.</p>
      <p>i.Subscribe UGX 20,000/- on Antenna Decoder for Basic Bouquet Customers, If onNOVA Antenna, Upgrade your bouquet to Basic then Subscribe the UGX 20,000/-;</p>
      <p>ii.Subscribe Classic monthly Bouquet at least once on Antenna decoder;</p>
      <p>iii.Subscribe Smart monthly Bouquet at least once on Antenna decoder;</p>
      <p>iv.Subscribe Super monthly Bouquet at least once on Antenna decoder;</p>
      <p>v.Buy a new decoder and activate.</p>
      <p>c.Participate to get points. In the group stage, you will get 2 points every time you correctly predict the position of one team, and you will get 1 point for each team in the best 4 third-placed teams, a total of 52 points. In the knockout stage, you need to predict before the game starts, otherwise you won’t get points of this game. You willget 3 points for each team in round of 16 and quarter-finals, and you will get 4 points for each team in semi-finals and final match, a total of 48 points. If you participate in these two predictions, you have chance to get 100 points. Finally, you will get lucky awards according to your points.</p>
      <p>4.Activity awards:</p>
      <p>a.Prediction Award: </p>
      <p>Winners of prediction award will be randomly selected from people who predict the most accurately on the June 25th and July 13th. The results will be displayed on the Facebook and StarTimes ON prediction page and Sanyuka TV.</p>
      <p>b.Lottery Award: </p>
      <p>Winners are randomly selected from all those who meet the conditions for participation on the June 18th, June 25th, July 1st, July 11th.</p>
      <p>During the event, if you log in for more than 10 days, you will surely win lucky award. The results will be displayed on the Facebook, StarTimes ON page and Sanyuka TV.</p>
      <p>c.Lucky Award: </p>
      <p>Points: >=90, 1 months Max package</p>
      <p>Points: <90 and >=70, 1 week Max package</p>
      <p>Points: <70 and >=50, 3 days Max package</p>
      <p>Points: <50 and >=30, 1 day Max package</p>
      <p>During the event, if you log in for more than 10 days, you will surely win lucky award.</p>
      <p>For prediction award and lottery award, those physical award, winners need to contact the organizer. After the necessary verification, awards will be awarded.</p>
      <p>For Lucky award, it will be released to the winners’ account in the 3 to 5 working days after the end of event.</p>
      <p>5.Additional information</p>
      <p>a.You need to provide an exact phone number and keep it unblocked. The phone number is an important certificate for awarding;</p>
      <p>b.Malicious registration is prohibited. If any malicious registration is found, the organizer has the right to cancel the qualification of the event and reserve the right to pursue their legal responsibility;</p>
      <p>c.The deadline for redemption is July 20th, if we fail to get in touch with you before the deadline, it will be considered invalid.</p>
      <p>d.The organizer reserves the right to change these terms and conditions and the right to final interpretation.</p>`,
      rule_text_gh: `<p>Submit your prediction for the final ranking of each group, and the four best third-place teams <strong>by June 19</strong></p>
      <p>AND</p>
      <p>Your prediction for the winner of each knockout stage game, all the way to the Final, <strong>by the beginning of each game</strong></p>
      <p>for a chance to win these AMAZING prizes!</p>
      <p><strong><u>The Prize</u></strong></p>
      <p>You will get points for every correct prediction. If you are among the BEST predictors, you will be entered into a draw for one of the three following prizes!</p>
      <p>Techno Phantom 10</p>
      <p>Techno Camon 17</p>
      <p>Techno Spark 7</p>
      <p>Winners are announced on StarTimes Facebook and Instagram page! Subscribe to them today to stay updated!</p>
      <p><strong><u>Remember!</u></strong></p>
      <p>Only active users of StarTimes decoders or VIP users of the APP are eligible to participate. Youneed to provide this information and a phone number when submitting your prediction and for receiving the prize.</p>
      <p>The deadline to redeem your prize is July 20. If we cannot get in touch with you then，your prize will be invalidated.</p>
      <p>*StarTimes reserves the right to change these terms and conditions at any time without prior notice.</p>`,
      share: 'Share',
      share_title: 'EURO2020 Prediction',
      share_text: 'I am watching Euro2020 on StartimesON, and I can win prizes by guessing the result of the match. Come and join me now!',
      confirm: 'Confirm',
      cancel: 'Cancel',
      group: 'Group',
      third_teams_title: 'Predict the four best third-placed teams',
      confirm_submit_info: 'Are you sure about your predictions？',
      prize_title: 'LIST OF PRIZES',
      result_tips_success: 'You have successfully submitted your predictions!',
      result_tips_end: 'This prediction has ended, please participate in the next one.',
      sign_in: 'Sign in',
      sign_in_info: 'Sign in to start your prediction!',
      vip_tips:
        'Please ensure that you have purchased a membership package or linked your DVB decoder, which is a prerequisite for obtaining prizes:',
      dvb_link_decode: 'LINK DECODER',
      ott_get_vip: 'GET VIP',
      phone_tips: 'In order to inform you when you win the prize, please fill in the correct contact information:',
      phone_error_info: 'Please enter a valid phone number!',
      phone_placeholder: 'Please enter your phone number',
      phone_confirm_info:
        'The phone number is your only proof of receiving the prize. Please check it carefully and you cannot modify it after submission.',
      network_error: 'Poor network, please check your network!',
      change_rank_tip: 'Click the up and down arrows to rank the teams',
      no_finish_tip: 'You need to choose the 4 best third-placed teams to complete your prediction!',

      // 二期补充
      next: 'NEXT',
      back: 'BACK',
      no_finish_tip2: 'Please complete all predictions before proceeding to the next round',
      no_participate: 'You did not participate in the last event.',
      no_prize: "Unfortunately, you didn't win the prize last time!",
      get_prize: 'Congratulations to you for getting ',
      get_point1: 'You have earned ',
      get_point2: ' points, predict to get more!',
      submit_success: 'You have successfully submitted your predictions! Stay tuned for the lucky draw results!',
      swipe_tip: 'Swipe to see all',
      loading: 'Loading...'
    },
    africa: {
      rule: 'REGRAS',
      share: 'PARTILHE',
      rule_title: `<p style="color:#CB043F;font-weight:bold;">REGRAS</p>`,
      rule_text: `<p>1. Envie suas previsões para o placar final, no início dos jogos</p><p>2. Para cada previsão, você tem a chance de entrar em um sorteio</p><p>Sistema de pontuação:</p><p>5 pontos, quando você prediz corretamente a pontuação final</p><p>3 pontos, quando você prediz corretamente o resultado do jogo & o número de gols marcados por uma das equipes</p><p>2 pontos, si voce somente acertar o numero de golos marcados por uma equipa</p><p>1 ponto, si voce acertar o resultado do jogo</p><p>Condições:</p><p>- Apenas usuários registrados são elegíveis para participar</p>`,
      prize_details: 'DETALHES DE PREMIAÇÃO',
      prize_details_text1: 'Os usuários com a maior pontuação serão recompensados com motocicletas',
      prize_details_text2: 'Usuarios com o segundo e terceiro serão premiados com MAXVIP por toda a vida',
      prize_details_text3: 'Os usuários com o quarto e o quinto serão recompensados com associação de três anos',
      prize_details_text4: 'Os usuários apartir de sexto a décimo serão premiados por um ano',
      fixture: 'CALENDÁRIO',
      africa_rank: 'RANKING DE PONTOS',
      points: 'Pontos: ',
      replay: 'REPETIR',
      predict: 'PREVER',
      predicted: 'PREVISTO',
      live: 'DIRECTO',
      over: 'FIM',
      my_points: 'Meus Pontos: ',
      my_ranking: 'Meu Ranking: ',
      lottery_title: 'AREA DE LOTERIA',
      lottery_des:
        'Para todas as previsões que fizer, podes ganhar 1 chance de participar do soreio e os usuarios que VIP ou que façam LINK de descodificador receberão 1 chance extra.',
      lottery_left: 'Sorteiros restantes: ',
      my_prize: 'MEU PRÉMIO',
      start: 'INICIE',
      has_got: 'teve',
      more_vote_title: 'COMO OBTER SORTEIOS',
      predict_btn: 'PREVEJA',
      predict_des: '1. Faça sua previsão',
      ott_btn: 'COMPRE VIP',
      ott_des: '2. Beneficios do VIP StarTimesON',
      dvb_btn: 'VINCULAR',
      dvb_des: '3. Beneficios de DVB StarTimes DVB',
      buy_btn: 'COMPRE',
      buy_des: '4. Compre qualquer quantidade de VIP ou recarregue uma vez',
      share_btn: 'PARTILHE',
      share_des: '5. Partilhe com novos usuarios para participar da actividade',
      lottery: 'Loteria',
      video_title: 'DESTAQUES',
      confirm: 'Decida ou confirmar',
      lottery_no_left: 'Em cada previsão vem uma chance para mais sorteiros! Compre VIP ou link o seu decoder para aumentar as chances de ganhar!',
      predict_success:
        'Submenta sua previsão e tenha chance de ganhar em grande! Compre VIP ou link o seu decoder para aumentar as chances de ganhar!',
      lottery_success: 'Parabéns por ter ganho ',
      lottery_sorry: 'Obrigado pela sua participação!',
      lottery_again: 'Parabens. Recebeu uma chance de ganhar!',
      no_left: ' Usaste todas as chances para ganhar!',
      to_signin: 'Participe do evento após o log in! Participe do evento para ganhar grandes prémios!',
      lottery_btn: 'SORTE',
      add_btn: 'aumente as chances',
      sign_btn: 'ENTRAR',
      continue_btn: 'CONTINUE',
      // 补充
      before_start: 'O evento não começou!',
      after_end: 'O evento terminou!',
      ok: 'OK',
      loading: 'Carregando…',
      download: 'BAIXAR'
    },
    appvote: {
      select_one: 'Seleccione um',
      select_more: 'Selecionar um ou mais',
      pre_vote: 'Votação pós-eleitoral',
      vote: 'Votação',
      download_btn: 'Descarregar agora',
      vote_success: 'A votação foi um sucesso! Descarrega o Startimes ON para veres os resultados e mais vídeos fantásticos que estão para vir!'
    },
    bssregister: {
      rule_btn: 'RULES',
      rule: '<p style="color:#55A081;font-weight:bold;">RULES</p>',
      rule_text: `\nOnline Audition\n\n1. Time of online audition: 9 Nov, 2024- 22 Dec, 2024\n\n2. Conditions\n\nⅠ.Record yourself singing the whole song\n\nⅡ.Record yourself immediately, do not edit or modify anything.\n\nⅢ.The song should carry all the sound characteristics that show the singer's feelings\n\nⅣ.The participant has to record his/her appearance. Fake singing is not allowed.\n\n3. How to register\n\nI. Online registration- StarTimes ON APP\n\nParticipants should record themselves singing the whole song, then upload their videos on YouTube/Tik Tok/Instagram (Copy link); Then download and open STARTIMES ON APP, enter the BSS interview section; fill in your important information, put your YouTube link while singing; submit, then wait for your work to be uploaded.\n\nII.Another way to register-Instagram\n\nRecord a video of yourself singing and then post it on Instagram, and put the hashtag #bssonlineaudition2024 and finally tag @startimestz *IMPORTANT: All the works of online participants will be reviewed for 48 hours after uploading, and the results will be placed in the next selections\n\n4.Rules\n\nAfter the publications, voting will officially open on StarTimes ON APP “Online Audition Election Voting Channel”. Until the end, 1~5 winners will qualify to enter the knockout stage of the competition.\n\nOffline Audition\n\n4. Time and place\n\nBSS interview dates\n\n• Nov 09 - 10 : Arusha 🇹🇿\n\n• Nov 16 - 17 : Mwanza 🇹🇿\n\n• Nov 23 - 24 : Kampala 🇺🇬\n\n• Nov 29 - 30 : Nairobi 🇰🇪\n\n• Dec 07 - 08 : Babati 🇹🇿\n\n• Dec 13 - 15 : Dar es Salaam 🇹🇿\n\n5. Method of interview\n\nCandidates who will participate in the offline interview are advised to go to the above mentioned locations due to the interview time.\n\n6. Selection rules\n\nThere are 5 opportunities for non-internet interviews in each interview (except Dar es Salaam), 4 expert judges will interview the participants with YES or NO. Participants who pass the interview that day will participate again in the second interview the next day in order to select those who will move forward in the competition.\n\n7. Others\n\nDue to the presence of many people who appear during the interview, the preparation of the session also takes place on the day of the interview. You are advised to arrive early at the interview location and follow the instructions. \n\n8. All Rights are Reserved by StarTimes `,
      loading: 'Loading...',
      name: 'NAME',
      sex: 'GENDER',
      male: 'Male',
      female: 'Female',
      select_placeholder: 'Please enter',
      birthday: 'DATE OF BIRTH',
      year: 'Year',
      month: 'Month',
      day: 'Day',
      number: 'PHONE NUMBER',
      number_error: 'Please enter correct phone number',
      country: 'COUNTRY',
      city: 'CURRENT RESIDENCE',
      profession: 'OCCUPATION',
      link: 'VIDEO LINK',
      link_placeholder: 'Video links for Tiktok/Instagram/Youtube',
      howto_getlink: 'HOW TO GET THE VIDEO LINK?',
      end_text: 'Sorry, registration is closed',
      offway_title: 'OFF-LINE REGISTRATION',
      offway_text: `Auditions for Bongo Star Search season 15 will be held in Arusha, Mwanza, Kampala Uganda, Nairobi Kenya, Babati and Dar es Salaam.<br/>It will start in Arusha on 09/11/2024. Get excited about this great opportunity. Regarding how to join the competition, please click on the link. Don't forget there are more opportunities waiting for you!`,
      success_title: 'Registration successful',
      success_text:
        'If approved, we will review your video and your video will be displayed on the APP within 48 hours. Don’t forget you’ve signed up!',
      ok: 'OK',
      share: 'SHARE',
      share_title: 'Beyond Borders Si Mchezooo!',
      share_text:
        'The choice is yours! Choose the candidate you like and help him participate in the Bongo Star Search 2024 participant search stage.',
      ke: 'Kenya',
      ug: 'Uganda',
      tz: 'Tanzania',
      profession_list: [
        'Sales/Marketing',
        'Accounting/Management',
        'Projects/Quality',
        'Information Technology/Network/Telecommunications',
        'Non-current Assets/Construction',
        'Finance/Funds',
        'Transportation/Logistics',
        'Manufacturing/Production',
        'Information Technology Equipment/Art/Craftsmanship',
        'Consulting/Legal/Education',
        'Service Sector',
        'Energy/Environment',
        'Agriculture',
        'Scientific Research',
        'Temporary Work/On-the-job Training/Others'
      ],
      title1: 'PROCESS OF JOINING ONLINE',
      title2: 'OTHER REGISTRATION METHODS',
      title3: 'HIGHLIGHTS',
      submit: 'SUBMIT'
    },
    bssvote: {
      rule_btn: 'RULES',
      rule: '<p style="color:#55A081;font-weight:bold;">RULES</p>',
      rule_text: `\nFrom Nov 9 to Dec 22, you have 5 votes every day after logging in. Votes will be totaled and valid until the end of the activity.\n\nYou can vote for any contestant you like!\n\nShare the link to your friends and ask them to download the StarTimes ON App to get more votes! You will get 5 more votes for each new user. The more new users you bring in, the more votes you get! And also, if you connect your Decoder with the App, or if you are a VIP of the App, you will get 20 more votes!\n\nEvery time you vote, you will get one chance to get StarTimes Decoder, Dish, or Max VIP of the Month for StarTimes ON and Coupons.\n\nPrizes will be awarded the next business day in Me-> My Coupons.\n\nThe top 10 candidates with the most votes will be able to enter the final interview, and finally 5-10 candidates will be selected by the teacher to participate in 2024BSS S15.`,
      new_info: 'Participate in the vote to get more votes',
      way_link: 'HOW TO GET MORE VOTES?',
      vote_left: 'Number of remaining votes: ',
      vote: 'VOTE',
      more_singer: 'VIEW ALL PARTICIPANTS',
      tosign: 'SIGN UP',
      tofinish: 'COMPLETE IT',
      finished: 'COMPLETED',
      invite: 'INVITE',
      invite_text: 'Successfully invited friends: ',
      info: `Every time you vote,<br />you will have a chance to win prizes.`,
      lottery_left: 'REMAINING DRAWS:',
      tip: 'FIND PRIZE ON ME -> MY COUPON',
      vote_title: 'VOTER FOR YOUR CHOICE',
      close: 'CLOSE',
      share_title: 'You are the next bingo star',
      share_text:
        'The choice is yours! Select your favorite candidate and help him participate in the Bongo Star Search 2024 participant search phase',
      ok: 'OK',
      share: 'SHARE',
      cancel: 'CANCEL',
      before_start: 'Voting starts on November 9th, so stay tuned!',
      after_end: 'Sorry, voting is closed',
      voteleft0: 'Sorry, your remaining votes are 0',
      get_more: 'HOW TO GET MORE VOTES?',
      nomore: 'The vote failed. Not enough votes',
      fail1: 'success! Share with friends to get more votes',
      fail2: 'success! You will get prizes by participating in the game',
      sign_tip: 'Go and participate in lucky draw',
      nomore_vote: 'Go vote for a chance to win good to draw. Every time you vote, you will have a chance to win prizes.',
      win_morevote: 'Congratulations! You got {0} votes again!',
      win_again: 'Congratulations! You have one more chance!',
      win_normal: 'Congratulations! You got {0}! Rewards will be issued on the second business day of My Me->Coupon.',
      sorry: 'Thanks for participation',
      getott: 'LIPIA VIP',
      getdvb: 'CONNECT DIKODA&APP',
      sign: 'REGISTER',
      toinvite: 'INVITE FRIENDS',
      title1: 'VOTE FOR THE CONTESTANT YOU SUPPORT',
      title2: 'HOW TO GET MORE VOTES?',
      title3: 'LUCK DRAW',
      title4: 'MORE VIDEOS'
    },
    bssresult: {
      rule_btn: 'RULES',
      share_btn: 'SHARE',
      rule_title: '<p style="color:#55A081;font-weight:bold;">Rules for voting</p>',
      rule_text:
        '\n1. From Nov 9 to Dec 22, you have 5 votes every day after logging in. Votes will be totaled and valid until the end of the transaction.\n\n2. You can vote for any contestant you like!\n\n3. Give the link to your friends and ask them to download the StarTimes ON App to get more votes! You will get 5 more votes for each new user. The more new users you bring in, the more votes you get! And also, if you connect your Decoder with the App, or if you are a VIP of the App, you will get 20 more votes!\n\n4. Every time you vote, you will get one chance to get StarTimes Decoder, Dish, or Max VIP of the Month for StarTimes ON and Coupons.\n\n5. Prizes will be awarded the next business day in Me-> My Coupons.\n\n6. The top 10 candidates with the most votes will be able to enter the final interview, and finally 5-10 candidates will be selected by the teacher to participate in 2024BSS S15.',
      share_title: 'You are the next Bongo star.',
      share_text:
        'The choice is yours! Choose the candidate you like and help him participate in the Bongo Star Search 2024 participant search stage.',
      ok: 'OK',
      highlights: 'MORE VIDEOS'
    },
    bsspopular: {
      rule_btn: 'RULES',
      share_btn: 'SHARE',
      rule_title: '<p style="color:#55A081;font-weight:bold;">Voting rules</p>',
      rule_text:
        '<p>1.During the event, you have 5 votes every day after logging in. The votes will be accumulated and valid until the end of the event.</p><p>2.You can vote for any participant you like!</p><p>3.Share the link with your friends and have them download the StarTimes ON App to get more votes! You will get 5 more votes for each new user. The more new users you bring, the more votes you get! And also if you link your Dikoda to the App, or become a VIP of the App, you will get 20 more votes!</p><p>4.Every time you vote, you will increase your chances of winning prizes.</p><p>5.Each user can get up to 50 votes per day by sharing the link with new users, and the number of votes received during the event will not exceed 1,000.</p><p>6.Prizes will be awarded the next day. Click "Me"->" My Coupons"and you will see your prizes.</p>',
      share_title: 'StarTimes ON',
      share_text: 'Bongo Star Search Season 15 Voting window for the most popular participants!!',
      ok: 'OK',
      cancel: 'CANCEL',
      to_more_vote: 'HOW TO GET MORE VOTES?',
      vote_left: 'Number of remaining votes:',
      vote: 'VOTE',
      tosign: 'Sign Up',
      tofinish: 'COMPLETE IT',
      finished: 'COMPLETED',
      invite: 'INVITE',
      invite_text: 'SUCCESSFULLY INVITE FRIENDS:',
      info: 'Every time you vote,you will have a chance to win prizes.',
      lottery_left: 'REMAINING DRAWS:',
      tip1: 'Coupons and prizes can be viewed here, click “ME” then “my coupon”',
      tip2: 'Users who win prizes,contact us to collect them from designated stores',
      vote_title: 'VOTE FOR YOUR FAVORITE',
      close: 'CANCEL',
      before_after: 'Activity has not started!',
      after_end: 'Activity is over!',
      voteleft0: 'Sorry, your remaining vote is 0.',
      nomore: 'The vote has failed. There are not enough votes left.',
      fail1: 'Successful! Involve friends to get more votes.',
      fail2: "Successful! You've got a chance to win a prize by going through the game on this page.",
      sign_tip: 'Please register to start the lucky draw.',
      nomore_vote: 'Go vote to win a lucky draw. Every time you vote, you have a chance to win a prize.',
      win_normal: 'Congratulations! You got {0}! Prizes will be awarded the next day. Click "Me"->" My Coupons"and you will see your prizes.',
      sorry: 'Thanks for participation.',
      has_got: 'has got'
    }
  },
  native: {
    guide: {
      channellistbottom: 'Sem mais canais',
      channelslist: ' Canais',
      channellist: ' Canai',
      searchbox: 'Nome ou código do canal',
      searchresults: ' resultados de pesquisa foram encontrados para ',
      search1result: '1 resultado de pesquisa foi encontrado para ',
      search0result: 'Não foram encontrados resultados de pesquisa para ',
      noepg: 'EPG não está disponível para hoje',
      tvguide: 'Guia',
      network_error: 'Falha de rede.'
    },
    exchangecode: {
      code: 'Código:',
      sure: 'Certo',
      tips: 'Parabéns! ! ! Preencha o código de resgate para resgatar a recompensa! ! !',
      no_sign: 'Somente novos usuários registrados podem participar desta atividade. Então inscreva-se agora! ! !',
      old_sign: 'Somente novos usuários registrados podem participar desta atividade! ! !',
      error_code: 'Este código é inválido, verifique e preencha novamente! ! !',
      repeat_code: 'Você já participou desta atividade e não pode participar novamente! ! !',
      repeat_device: 'Este dispositivo já participou da atividade e não pode participar novamente! ! !',
      h5_call: 'O código de resgate só pode ser usado no aplicativo, faça o download e instale o aplicativo! ! !',
      success_tip1: 'Parabéns! ! ! Você consegue ',
      success_tip2: ', assista ao vídeo agora! ! !',
      server_error: 'Erro de servidor'
    }
  },
  template: {
    dvbActivity: {
      startimes_on_app: 'STARTIMES ON APP',
      download: 'BAIXE',
      rule: 'regra',
      rule_text:
        '<p>1.Um cartão de decoder pode ser conectado a um máximo de três contas de Starimes ON, o que permitirá que você desfrute de conteúdo premium gratuitamente.</p><p>2.Digite o número do seu cartão e os últimos seis dígitos do decoder, após da validação, podia conectar o cartão inteligente atráves de digitar o número de telemóvel</p><p>3.Se o número de telemóvel inserido não estiver registrado, você pode seguir as instruções para baixar o aplicativo e conectar o seu cartão depois de concluir o registo.</p><p>4.Se você já registou o seu número de telemóvel, podia conectar directamente ao cartão do decoder.</p>',
      smart_card: 'ID DO CARTÃO INTELIGENTE',
      decoder: 'ID do decodificador(Últimos seis dígitos)',
      err_code12: 'número de cartão inválido',
      err_code13: 'Número do cartão inteligente e número de série de decodificador não se coincidem',
      err_code21: 'FALHA NA CONEXÃO. O cartão está conectado para além da limitação (máximo de três usuários por cartão)',
      next: 'PRÓXIMO',

      limit_tip1: 'Este cartão pode ser conectado a um total de 3 contas de APP. Atualmente, ',
      limit_tip2: ' contas estão conectadas, ',
      limit_tip3: ' contas mais poderão ser conectadas',
      wait_bind: 'Aguardando conexão...',
      phone_number: 'Número de telemóvel:',
      err_code1: 'Cartão conectado com sucesso',
      err_code5: 'Número de telemóvel errado',
      err_code15: 'O usuário já conectou este cartão',
      bind: 'Activar',

      off: 'desconto',
      for_order_above: 'Para pedido acima',
      coupon: 'cupão',
      recharge: 'Conecte',
      congratultions: 'Parabéns!',
      got_right: 'Ganha os benefícios de Startimes ON!',
      right_title1: 'Plano familiar',
      right_content1: 'Um descodificador pode ser adicionado a até 3 membros da família em sua casa',
      right_title2: 'Canal Gratuito',
      right_content2: 'Assista Todos os Canais Gratuitos do teu pacote',
      right_title3: 'Conteúdo VOD grátis',
      right_content3: 'Aproveite gratuitamente sem precisar de outra subscrição bastando estar no pacote Clássico/Super',
      benefits: 'Active já os benefícios',
      highlights: 'Destaques',

      ok: 'OK',
      cancel: 'Cancel',
      server_error: 'Erro de servidor',
      before_start: 'O evento não começou!',
      after_end: 'O evento terminou!'
    },
    vote: {
      share: 'PARTILHE',
      vote_left: 'Restantes votos: ',
      vote: 'Vote',
      sign_tip: 'Faça login agora ',
      ott_tip: 'Junte-se ao membro de OTT ',
      dvb_tip: 'Junte seu cartão de DVB ',
      pay_tip: 'Compre produtos ',
      pay_dvb_tip: 'Subscribe StarTimes Decoder ',
      comment_tip: 'Publicar um comentário com sucesso ',
      pay_mtn_tip: 'Subscribe ${0} MTN CallerTunez ',
      share_tip: 'Partilhe o evento',
      to_finish: 'Fazer',
      finished: 'Feito',
      to_buy: 'Comprar',
      to_share: 'Partilhar',
      more_vote: 'obter mais votos',
      how_many_vote: 'Quantos votos quer dar a ele?',
      ok: 'OK',
      cancel: 'Cancelar',
      before_start: 'O evento não começou!',
      after_end: 'O evento terminou!',
      server_error: 'Erro de servidor!',
      vote_success: 'Vote com sucesso!',
      vote_error: 'O voto falhou!',
      vote0_get_more: '0 votos restantes, obtenha mais votos!',
      copied: 'Web link has been copied',
      no_support_copy: 'Copy is not supported on your browser, please try to make a long press to copy'
    },
    voteLottery: {
      sign_alert: '请登录后抽奖',
      lottery_left: 'LOTTERY LEFT:',
      has_got: 'has got',
      win_tip:
        'Kuponi na zawadi za wanachama zinaweza kutazamwa Tkwangu->Kuponi yangu baada ya tukio kuisha</br>Watumiaji wanaoshinda zawadi za vitu watawasiliana nawe ili kuzichukua kwenye maduka yetu yaliyoteuliwa',
      lottery0_get_more: '没有抽奖机会了，投票获取更多抽奖机会吧！',
      win_text: '恭喜你, 获得了',
      win_vote: 'xxx票!',
      win_thanks: '很抱歉没中奖',
      win_try_again: '恭喜你, 你还有一次机会!',
      my_prize: 'My Prize',
      loading: '加载中...',
      empty_list: '你还没有中奖哦'
    },
    guidebind: {
      share: 'Share',
      ok: 'OK',
      cancel: 'Cancel',
      after_end: 'The event has ended',
      after_end_toast: 'The current event has ended. Please stay tuned to Startimes ON for more amazing discounts!',
      server_error: 'Server error!',
      btn_down: 'Download & Redeem',
      btn_sign: 'Sign In & Redeem',
      link_not_bind: 'Why Not a TV Reward? >',
      btn_not_bind: 'Redeem & Use now',
      link_bind: 'Redeem a mobile VIP >',
      btn_bind: 'Join TV PROMO',
      sign_in_content:
        '<div style="text-align: left;line-height: 20px;">For a better experience in Easter Promo, please remember to <span style="color: #ffc107;font-weight: bold;">SIGN IN</span> with your<br />1. <span style="color: #f44336;font-weight: bold;">Phone Number</span> <br />2. <span style="color: #f44336;font-weight: bold;">Smartcard Number</span> as your <span style="font-weight: bold;">password</span>. <br />Then ALL Unlimited movies&TV shows shall be available and FREE for u ONLY!</div>'
    },
    userfission: {
      share: 'SHARE',
      like: 'LIKE',
      liked: 'LIKED',
      sure: 'SURE',
      join_btn: 'JOIN NOW',
      prize_title: 'Congratultions',
      share_title: 'ACTIVITY',
      like_title: 'ACTIVITY',
      video_title: 'JOIN AND ENJOY',
      step_title: 'HOW CAN I JOIN THIS ACTIVITY',
      ok: 'OK',
      cancel: 'Cancel',
      after_end: 'Sorry, the activity has ended!',
      server_error: 'Server error! Try again later.',
      country_error: 'The activity in the current country has not started yet, please wait a little!',
      sign_tip: 'Login to partiaipate in the activity',
      has_got: 'has got',
      congratultions1: 'Congratultions!!! You have got ',
      congratultions2: 'Your friend ${0} have got ',
      for_free: ' FOR FREE',
      my_bonus_btn: 'MY BONUS DETAIL >',
      my_bonus: 'Bonus details',
      first_share: 'FIRST TIME SHARE THIS PAGE TO YOUR FRIENDS, GET /*${0} IMMEDIATELY*/',
      has_share: 'YOU HAVE GOT /*${0}*/ LIKES FROM YOUR FRIENDS',
      share_excess: 'GET MORE LIKES from YOUR FRIENDS, GET /*MORE VIP*/',
      liked_excess: 'You have helped your friends get ',
      like_excess: 'LIKE FOR your friend, GET MORE VIP',
      like_no_excess: 'Many of your friends have received benefits, hurry up and participate in the activity to get FREE STARTIMES ON ',
      like_success: 'Successful! Thanks for your action.',
      like_limit_tip: 'The opportunity to like has reached the upper limit for today, open the StarTimes ON, participate in the ACTIVITY'
    },
    unitmember: {
      error_text: 'Please enter a valid phone number.',
      placeholder: 'Número de telemóvel',
      ok: 'OK',
      server_error: 'Erro de servidor',
      before_start: 'O evento não começou!',
      after_end: 'O evento terminou!'
    }
  },
  clause: {
    comment: {
      title: '《Directrizes para comentários》',
      desc1:
        'Quando utilizares o StarTimes ON, estarás numa comunidade de amigos rica em conteúdos. As seguintes directrizes ajudam a garantir que todos tenham uma experiência divertida e agradável no StarTimes ON.',
      desc1:
        'Quando utilizares o StarTimes ON, estarás numa comunidade de amigos rica em conteúdos. As seguintes directrizes ajudam a garantir que todos tenham uma experiência divertida e agradável no StarTimes ON.',
      desc2: 'Se achas que viste conteúdo que viola estas regras, clica no "ícone da bandeira".',
      subTitle1: '- Spam e Engano',
      content1:
        'A confiança é a base sobre a qual o StarTimes ON é construído, e o StarTimes ON não tolera a publicação de conteúdo que tenha a intenção de enganar, iludir ou defraudar outros utilizadores, ou spam.',
      content1:
        'A confiança é a base sobre a qual o StarTimes ON é construído, e o StarTimes ON não tolera a publicação de conteúdo que tenha a intenção de enganar, iludir ou defraudar outros utilizadores, ou spam.',
      subTitle2: '- Conteúdo sensível',
      content2:
        'Queremos proteger os nossos utilizadores, especialmente os menores. Por isso, evite publicar comentários que ponham em causa a segurança das crianças.',
      content2:
        'Queremos proteger os nossos utilizadores, especialmente os menores. Por isso, evite publicar comentários que ponham em causa a segurança das crianças.',
      subTitle3: '- Conteúdo violento ou perigoso',
      content3:
        'StarTimes ON não permite a publicação de discursos de ódio, comportamento predatório, conteúdo escrito de forma violenta, ataques maliciosos e conteúdo que promova comportamentos prejudiciais ou perigosos.',
      content3:
        'StarTimes ON não permite a publicação de discursos de ódio, comportamento predatório, conteúdo escrito de forma violenta, ataques maliciosos e conteúdo que promova comportamentos prejudiciais ou perigosos.',
      subTitle4: '- Itens controlados',
      content4: 'Por favor, não coloque produtos controlados para venda na StarTimes ON que violem as políticas locais.',
      subTitle5: '- Informações falsas',
      content5:
        'A StarTimes ON não permite a postagem de certos tipos de conteúdo enganoso ou conteúdo enganoso que possa representar um sério risco de danos extremos. Isso inclui tipos específicos de informações falsas que podem causar danos no mundo real (como a promoção de remédios ou curas prejudiciais), tipos específicos de conteúdo que são manipulados tecnologicamente ou conteúdo que interfere no processo democrático.',
      desc3:
        'Por favor, cumpra rigorosamente estas regras. Se o seu comportamento dentro ou fora da Plataforma prejudicar os nossos utilizadores, comunidades, funcionários ou ecossistema, poderemos tomar medidas com base numa combinação de factores, incluindo, entre outros, a gravidade do comportamento e o facto de ser ou não habitualmente prejudicial. No caso de tal comportamento, podemos suspender os privilégios de fala da sua conta para comportamentos menos graves, ou encerrar a sua conta para comportamentos mais graves.'
    },
    screen: {
      title1: 'Como usar a transmissão de tela',
      p1:
        '1. Etapa 1: confirme se o dispositivo e o telefone estão conectados ao mesmo Wi-Fi, abra o aplicativo StarTimes no dispositivo de transmissão de tela<br/>2. Etapa 2: clique no botão de transmissão de tela da TV no canto superior direito do player do aplicativo StarTimes no telefone para entrar na interface de seleção do dispositivo de transmissão de tela e selecione o dispositivo de TV que baixou o aplicativo StarTimes para concluir a transmissão de tela.',
      title2: 'O dispositivo de transmissão de tela não pode ser encontrado no telefone',
      p2:
        'Você pode verificar da seguinte forma:<br/>1. O dispositivo de transmissão de tela tem o aplicativo StarTimes instalado. Se não estiver instalado, você pode abrir a loja de aplicativos da TV/box, baixar o aplicativo "StarTimes" e transmitir a tela para assistir.<br/>2. O dispositivo de transmissão de tela está ligado e conectado ao mesmo Wi-Fi que o telefone.<br/>3. O dispositivo suporta transmissão de tela. Ou consulte o fabricante do dispositivo para obter ajuda.<br/>4. As funções de isolamento de AP e modo convidado do roteador foram desligadas e a rede do amplificador de sinal não está conectada. Se não for transmitido normalmente, você pode reiniciar o roteador e outros dispositivos de rede.<br/>5. Para iOS 14. iPadOS 14 ou superior, confirme se a permissão de rede local está ativada.<br/>6. Reinicie o aplicativo StarTimes e tente transmitir a tela novamente.',
      title3: 'Como corrigir a falha de transmissão de tela?',
      p3:
        'Você pode tentar as duas soluções a seguir:<br/>1. Verifique se a TV/box pode acessar a rede.<br/>2. Verifique se o aplicativo StarTimes foi instalado na TV ou no TV box. Caso contrário, baixe o aplicativo "StarTimes" da loja de aplicativos da TV/Box.',
      title4: 'A tela congela durante a transmissão:',
      p4:
        '1. A velocidade atual da rede ou seu dispositivo de transmissão de tela pode não suportar vídeo de alta definição. É recomendável reduzir a qualidade do vídeo para garantir uma reprodução suave.<br/>2. Verifique o acesso do dispositivo de transmissão de tela à sua rede WIFI.<br/>3. Certifique-se de que a velocidade da sua rede esteja estável.<br/>4. Nenhum aplicativo faz grande uso da largura de banda da sua rede local.',
      title5: 'Ao transmitir, há problemas como pular episódios ou retomar a reprodução.',
      p5: 'É recomendado reiniciar o aplicativo StarTimes e iniciar a transmissão de tela novamente, mantendo a conexão de rede normal.',
      title6: 'Por que alguns vídeos não suportam transmissão de tela?',
      p6: 'Devido a direitos autorais. Alguns vídeos não suportam reprodução via transmissão de tela.',
      title7: 'Como transmitir a tela para um computador para visualização?',
      p7: 'Não suportado.',
      TVtitle: 'Método de utilização da transmissão de ecrã',
      step1:
        '<span style="font-weight: bold;">Passo 1:</span> Abra o dispositivo de espelhamento de tela e instale o aplicativo StarTimes nele, garantindo que o dispositivo esteja conectado ao mesmo Wi-Fi que o telefone',
      step2:
        '<span style="font-weight: bold;">Passo 2:</span> Clique na projeção da tela da TV no canto superior direito do StarTimes App player no seu celular para entrar na interface de projeção da tela. Selecione o dispositivo de projeção da tela que baixou o StarTimes App para concluir a projeção da tela.'
    }
  }
}
